var _defs, _g, _g2, _g3, _g4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLivup(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.851562 37.503906 L 177.957031 37.503906 L 177.957031 173.714844 L 109.851562 173.714844 Z M 109.851562 37.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.847656 181.640625 L 177.953125 181.640625 L 177.953125 326.640625 L 109.847656 326.640625 Z M 109.847656 181.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 197.070312 37.503906 L 265.175781 37.503906 L 265.175781 173.714844 L 197.070312 173.714844 Z M 197.070312 37.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 197.066406 181.640625 L 265.175781 181.640625 L 265.175781 326.640625 L 197.066406 326.640625 Z M 197.066406 181.640625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f77611",
    d: "M 177.957031 139.660156 C 177.957031 158.46875 162.710938 173.714844 143.902344 173.714844 C 125.097656 173.714844 109.851562 158.46875 109.851562 139.660156 L 109.851562 71.554688 C 109.851562 52.746094 125.097656 37.503906 143.902344 37.503906 C 162.710938 37.503906 177.957031 52.746094 177.957031 71.554688 L 177.957031 139.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc33",
    d: "M 177.953125 292.464844 C 177.953125 311.339844 162.707031 326.640625 143.898438 326.640625 C 125.09375 326.640625 109.847656 311.339844 109.847656 292.464844 L 109.847656 215.816406 C 109.847656 196.941406 125.09375 181.640625 143.898438 181.640625 C 162.707031 181.640625 177.953125 196.941406 177.953125 215.816406 L 177.953125 292.464844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#38ded6",
    d: "M 265.175781 139.660156 C 265.175781 158.46875 249.929688 173.714844 231.125 173.714844 C 212.316406 173.714844 197.070312 158.46875 197.070312 139.660156 L 197.070312 71.554688 C 197.070312 52.746094 212.316406 37.503906 231.125 37.503906 C 249.929688 37.503906 265.175781 52.746094 265.175781 71.554688 L 265.175781 139.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#04c362",
    d: "M 265.171875 292.464844 C 265.171875 311.339844 249.925781 326.640625 231.121094 326.640625 C 212.316406 326.640625 197.070312 311.339844 197.070312 292.464844 L 197.070312 215.816406 C 197.070312 196.941406 212.316406 181.640625 231.121094 181.640625 C 249.925781 181.640625 265.171875 196.941406 265.171875 215.816406 L 265.171875 292.464844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLivup);
export default __webpack_public_path__ + "static/media/logo-livup.b8ca3a921483e72969cd22d18fe6bbd4.svg";
export { ForwardRef as ReactComponent };